let IntentosPostPdf = 0;
export const PostPdf = (url, body, resp) => {
    fetch(url, {
        method: 'POST',
        body: JSON.stringify(body),
        headers:{'Content-Type' : 'application/json', 'charset' : 'UTF-8'},})
    .then(response => response.blob())
    .then(blob => {
        if (blob.size < 10) {
            resp ("error");
        }else{
            let url = window.URL.createObjectURL(blob);
            resp(url)
        }
    },error => {
        IntentosPostPdf++;
        (IntentosPostPdf > 5) ? IntentosPostPdf = 0 : PostPdf(url, body, (respuesta) => {
            resp(respuesta)
        })
        console.error('Ocurrió un error al cargar. Reintentando. ', error);
    })
}

export const PrintPdf = (url, body, resp) => {
    fetch(url, {
        method: 'POST',
        body: JSON.stringify(body),
        headers:{'Content-Type' : 'application/json', 'charset' : 'UTF-8'}, 
    }).then(function(response) {
        return response.blob();
    }).then(function(myBlob) {
        var objectURL = URL.createObjectURL(myBlob);
        document.querySelector('#pdf-frame').src = '';
        document.querySelector('#pdf-frame').src = objectURL;
        objectURL = URL.revokeObjectURL(myBlob);
    }).then(
        function() {
            window.setTimeout(function() {
                document.querySelector('#pdf-frame').contentWindow.print();
                resp("ok")
            }, 1000)
        });
}


// WEBPACK FOOTER //
// ./src/shared/PostPdf.jsx